export default { sha: '7299189a4e351d7dea96c75fafdc59f7fdeb4cbe', buildNumber: 'undefined' }
